export default __webpack_public_path__ + "static/media/Graphik-Regular.7d0d6d56.ttf";